import { combineReducers } from "redux";

import foodCategoriesReducer from "./foodCategories";
import financeRestaurantReducer from "./financeRestaurants";
import financeDriversReducer from "./financeDrivers";
import ordersReportReducer from "./orderReports";
import cuisineReducer from "./cuisine";
import userReducer from "./user";
import driverReducer from "./driver";
import customerReducer from "./customer";
import authReducer from "./auth";
import operationsReducer from "./operations";
import livechatReducer from "./livechat";
import managmantDataReducer from "./managmantDashboardData";
import reportsSettlementReducer from "./reportsSettlement";
import settingsReducer from "./settings";

export default combineReducers({
  reportsSettlement: reportsSettlementReducer,
  financeRestaurant: financeRestaurantReducer,
  financeDrivers: financeDriversReducer,
  managmantData: managmantDataReducer,
  ordersReport: ordersReportReducer,
  driver: driverReducer,
  customer: customerReducer,
  operations: operationsReducer,
  auth: authReducer,
  foodCategories: foodCategoriesReducer,
  cuisines: cuisineReducer,
  users: userReducer,
  livechat: livechatReducer,
  settings: settingsReducer
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js